import React from "react";
import Meta from "components/common/Meta";
import { AppContentContainer } from "components/common/layouts/appLayout/AppContentContainer";
import { PRIVATE_ROUTE_DETAILS } from "constants/routes";
import HomeCard, {
  HomeCardContainer,
} from "components/common/ui/card/HomeCard";
import AdminIllustration from "components/common/images/AdminIllustration";
import styles from "components/home/Home.module.scss";
import IconWarning from "components/common/icons/IconWarning";

const ViewHome = () => {
  return (
    <AppContentContainer
      className={styles.root}
      maxWidth={true}
      spacing="extra"
    >
      <Meta title={"Home"} />

      <IconWarning
        style={{
          width: 100,
          height: 100,
          color: "red",
        }}
      />
      <h1 style={{ color: "red" }}>WARNING: This site is no longer in use</h1>
      <p className={styles.pageBlurb}>
        This version of UCCIS has been deprecated! <br />{" "}
        <b>
          Please visit{" "}
          <a href="https://uccis.rnzcuc.org.nz">https://uccis.rnzcuc.org.nz</a>{" "}
          to access the most recent version
        </b>
      </p>

      <br />
      <HomeCardContainer>
        <HomeCard
          title={"Admin"}
          description={"Create and manage users"}
          route={PRIVATE_ROUTE_DETAILS.ADMIN_USERS}
          svg={AdminIllustration}
        />
        {/*<HomeCard
          title={"My Profile"}
          description={"View your membership details & update your profile"}
          route={PRIVATE_ROUTE_DETAILS.MY_PROFILE}
          svg={DoctorIllustration}
        />*/}
        {/*<HomeCard*/}
        {/*  title={"PDP"}*/}
        {/*  description={"[Add text]"}*/}
        {/*  route={PRIVATE_ROUTE_DETAILS.MY_PROFILE}*/}
        {/*  svg={ReportsIllustration}*/}
        {/*/>*/}
        {/*<HomeCard
          title={"CPD"}
          description={
            "View & update your Continuing Professional Development Plan"
          }
          route={PRIVATE_ROUTE_DETAILS.MY_PLANS}
          svg={PlanIllustration}
        />
        <HomeCard
          title={"Training Programme"}
          description={"View & update your Training Programme Summary"}
          route={PRIVATE_ROUTE_DETAILS.MY_TPS}
          svg={PlanIllustration}
        />*/}
        {/*<HomeCard*/}
        {/*  title={"Peer Groups"}*/}
        {/*  description={*/}
        {/*    "[Add text]"*/}
        {/*  }*/}
        {/*  route={PRIVATE_ROUTE_DETAILS.MY_PLANS}*/}
        {/*  svg={PlanIllustration}*/}
        {/*  // col={12}*/}
        {/*/>*/}

        {/*<HomeCard*/}
        {/*  title={"Learning Resources"}*/}
        {/*  description={*/}
        {/*    "Access learning resources and track your \n completion progress"*/}
        {/*  }*/}
        {/*  route={PRIVATE_ROUTE_DETAILS.LEARNING_RESOURCES}*/}
        {/*  svg={LearningIllustration}*/}
        {/*/>*/}
        {/*<HomeCard*/}
        {/*  title={"Reports"}*/}
        {/*  description={"Office reports, data extracts and summaries"}*/}
        {/*  route={PRIVATE_ROUTE_DETAILS.ADMIN_REPORTS}*/}
        {/*  svg={ReportsIllustration}*/}
        {/*/>*/}
      </HomeCardContainer>
    </AppContentContainer>
  );
};

export default ViewHome;
